import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorBackground, csColorBorder, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const style = css`
  :host {
    display: contents;
  }

  cse-modal {
    --cse-modal-width: 480px;
  }

  .copy-header {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing03};
    width: 100%;
  }

  .copy-target-description {
    --cs-font-body-s-font-size: 12px;
    --cs-font-body-s-font-size-mobile: 12px;
    --cs-font-body-s-line-height: 1.4;
    --cse-text-color: rgb(107, 115, 133);
  }

  .copy-body {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    width: 100%;
    box-sizing: border-box;
  }

  .copy-intro {
    margin-bottom: 15px;
  }

  .copy-label {
    --cs-font-caption-m-font-size: 12px;
    --cs-font-caption-m-font-size-mobile: 12px;
    --cs-font-caption-m-font-weight: 500;
    --cs-font-caption-m-letter-spacing: 0.06em;
    --cs-font-caption-m-text-transform: uppercase;
    --cse-text-color: rgb(74, 81, 96);
  }

  .copy-targets {
    --cse-radio-button-group-gap: 8px;
    display: block;
  }

  .copy-target {
    --cse-radio-button-gap: 12px;
    display: block;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 12px;
    border: ${csBorder.width} solid ${csColorBorder.light};
    border-radius: ${csBorder.radiusSubtle};
    cursor: pointer;
  }

  .copy-target.selected {
    border-color: ${csColorAction.primary};
    background: ${csColorBackground.secondary};
  }

  .copy-target[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .copy-target-text {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .copy-target-title {
    --cs-font-body-font-size: 14px;
    --cs-font-body-font-size-mobile: 14px;
    --cs-font-body-font-weight: 700;
  }

  .copy-summary {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    padding: ${csSpacing.spacing06};
    border-radius: ${csBorder.radiusMedium};
    background: ${csColorBackground.secondary};
  }

  .copy-skip-existing {
    --cse-checkbox-font-size: 14px;
  }

  .copy-summary-warning {
    --cse-text-color: ${csColorFunctional.warning};
  }

  .copy-footer {
    display: flex;
    justify-content: flex-end;
    gap: ${csSpacing.spacing04};
    width: 100%;
  }
`
